export default __webpack_public_path__ + "locales/lv/ConvertPasswordDialog.json?hash=3721d4240c5de53c7569adf2665646b3";